import { computed, defineComponent, ref } from '@vue/composition-api';
import JsonViewer from '@/components/json-viewer/json-viewer.vue';
import { parseProviderPayload } from './helpers';

export default defineComponent({
  components: { JsonViewer },
  props: {
    payload: { type: String, default: '' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    provider: { type: String, default: '' },
  },
  setup(props) {
    const dialog = ref<HTMLDialogElement | null>(null);
    const showRaw = ref(false);
    const parsed = computed(() => parseProviderPayload(props.payload));
    const open = () => {
      showRaw.value = parsed.value === null;
      dialog.value?.showModal();
    };
    const close = () => dialog.value?.close();

    return { dialog, showRaw, parsed, open, close };
  },
});
